var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10631",
    "data-name": "Group 10631",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.713,
    height: 11.441,
    viewBox: "0 0 12.713 11.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2980",
    "data-name": "Rectangle 2980",
    width: 12.713,
    height: 11.442,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10630",
    "data-name": "Group 10630",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28431",
    "data-name": "Path 28431",
    d: "M12.574,2.238A3.182,3.182,0,0,0,9.535,0H3.178A3.182,3.182,0,0,0,.139,2.238,3.36,3.36,0,0,0,0,3.178V8.263a3.179,3.179,0,0,0,3.178,3.178H9.535a3.179,3.179,0,0,0,3.178-3.178V3.178a3.36,3.36,0,0,0-.139-.94m-9.4-.967H9.535a1.912,1.912,0,0,1,1.881,1.6L6.356,5.632,1.3,2.874a1.912,1.912,0,0,1,1.881-1.6m8.263,6.992A1.912,1.912,0,0,1,9.535,10.17H3.178A1.912,1.912,0,0,1,1.271,8.263V4.311L6.052,6.916a.64.64,0,0,0,.609,0l4.781-2.605Z",
    fill: "#e7f0f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.f84a0f961880c9c99b01139e54b09981.svg";
export { ForwardRef as ReactComponent };